
import priceCountryMixin from '@/mixins/priceCountryMixin'

const omitNullValues = (key, value) => (value === null ? undefined : value)

export default {
  mixins: [priceCountryMixin],
  props: {
    products: Array,
    category: Object,
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      returnDays: null,
    }
  },
  async fetch() {
    if (!this.hasStructuredData) return
    await this.$configurationService
      .getPublic('order_returns_max_delay')
      .then(({ data }) => {
        this.returnDays = parseInt(data.value)
      })
      .catch(() => {})
  },
  head() {
    if (!this.structuredData) return {}
    const scripts = [
      {
        innerHTML: JSON.stringify(this.structuredData, omitNullValues),
        type: 'application/ld+json',
      },
    ]
    if (this.returnPolicy) {
      scripts.push({
        innerHTML: JSON.stringify(this.returnPolicy),
        type: 'application/ld+json',
      })
    }
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: scripts,
    }
  },
  computed: {
    hasStructuredData() {
      const data = this.category.structured_data
      return !!data && !Array.isArray(data) && data.lowPrice > 0
    },
    computedAggregateRating() {
      if (this.reviews && this.reviews.length > 0) {
        const totalStars = this.reviews.reduce(
          (sum, review) => sum + (review.stars || 0),
          0
        )
        const avgRating = totalStars / this.reviews.length
        return {
          '@type': 'AggregateRating',
          ratingValue: avgRating.toFixed(1),
          ratingCount: this.reviews.length,
          reviewCount: this.reviews.length,
          bestRating: 5,
          worstRating: 1,
        }
      }
      if (
        this.category.structured_data &&
        this.category.structured_data.ratingCount
      ) {
        return {
          '@type': 'AggregateRating',
          ratingValue: this.category.structured_data.ratingValue,
          ratingCount: this.category.structured_data.ratingCount,
          reviewCount: this.category.structured_data.ratingCount,
          bestRating: this.category.structured_data.bestRating,
          worstRating: this.category.structured_data.worstRating,
        }
      }
      return null
    },
    returnPolicy() {
      if (!this.returnDays) return null
      return {
        '@context': 'https://schema.org/',
        '@type': 'MerchantReturnPolicy',
        '@id': '#return_policy',
        applicableCountry: this.priceCountry,
        returnPolicyCategory:
          'https://schema.org/MerchantReturnFiniteReturnWindow',
        merchantReturnDays: this.returnDays,
        returnMethod: 'https://schema.org/ReturnByMail',
        returnFees: 'https://schema.org/FreeReturn',
      }
    },
    structuredData() {
      if (!this.hasStructuredData) return null
      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        '@id': '#product',
        name: this.category.meta_title
          ? this.category.meta_title
          : this.category.name,
        description:
          this.category.meta_description || this.category.description || '',
        category: this.category.meta_title
          ? this.category.meta_title
          : this.category.name,
        brand: {
          '@type': 'Brand',
          name: 'AGM Vision',
        },
        image: this.getImagesFromProducts(),
        url: this.$config.url + this.$route.path,
        aggregateRating: this.computedAggregateRating,
        offers: {
          '@type': 'AggregateOffer',
          offerCount:
            this.category.products_recursive_count || this.products.length,
          highPrice: this.category.structured_data.highPrice,
          lowPrice: this.category.structured_data.lowPrice,
          availability: 'https://schema.org/InStock',
          priceCurrency: 'EUR',
          ...(this.returnDays
            ? { hasMerchantReturnPolicy: { '@id': '#return_policy' } }
            : {}),
        },
      }
    },
  },
  methods: {
    getImagesFromProducts() {
      let images_arr = []
      if (this.products && this.products.length > 0) {
        this.products.forEach(item => {
          const url = item.variant?.images?.[0]?.url
          if (url) images_arr.push(url)
        })
      }
      if (images_arr.length === 0 && this.category.images?.[0]?.url) {
        images_arr.push(this.category.images[0].url)
      }
      return images_arr
    },
  },
}
